// SPDX-License-Identifier: AGPL-3.0-or-later
// Pure histogram binning — no DOM. Tested for correct bin assignment and counts.

export interface Bin { x0: number; x1: number; count: number; items: number[] }

/**
 * Bin `values` into `nbins` equal-width bins spanning [min, max]. The max value
 * falls in the last bin (right edge inclusive). Returns bins left→right.
 */
export function binValues(values: number[], nbins: number): Bin[] {
  const finite = values.filter((v) => Number.isFinite(v));
  const n = Math.max(1, Math.floor(nbins));
  if (!finite.length) return [];
  let min = Math.min(...finite);
  let max = Math.max(...finite);
  if (min === max) { max = min + 1; } // degenerate: single-value column
  const width = (max - min) / n;
  const bins: Bin[] = Array.from({ length: n }, (_, i) => ({
    x0: min + i * width,
    x1: min + (i + 1) * width,
    count: 0,
    items: [],
  }));
  for (const v of finite) {
    let idx = Math.floor((v - min) / width);
    if (idx >= n) idx = n - 1; // max lands in last bin
    if (idx < 0) idx = 0;
    bins[idx].count++;
    bins[idx].items.push(v);
  }
  return bins;
}
